import Vue from 'vue'
import ConfigMixin from '@/mixins/Config.js'
import RootUserMixin from 'GroomyRoot/mixins/User.js'
import Constants from 'Constants'
import { loadLocale } from 'GroomyRoot/assets/js/i18n.js'
import { EventBus } from 'EventBus'

export default Vue.util.mergeOptions(RootUserMixin, {
	data: () => ({
		need_valid_mail: false
	}),
    methods: {
        checkLogin: async function(email, password) {           
            return this.$request.request_post_api("UserMixin::checkLogin", Constants.USER_LOGIN, {
                    email: email,
                    password: password
                }, false, { sync:false })
                .then(response => {
                    if(response.code_retour === 0) {
                        const data = response.retour
                        this.persistUserSession(data.token, data.licence_key, data.licence_username, data.user_id, data.valid_user, data.valid_mail, data.lang)
                        this.persistUserLicence(data)
						this.need_valid_mail = data.valid_mail
                    }

                    return response
				})
		},
		
		async redirectPostLogin(redirect='') {
			if(!this.need_valid_mail) {
				this.$router.push({ name: 'EmailValidation' })
				return
			}

            const all_tiers = await this.getTiersByUser()
            this.setConfig('all_tiers', all_tiers)
            // if(all_tiers.length > 1) {
            //     this.$router.push({name: 'SwitchTiers'})
            //     return false
            // }
            // else if(all_tiers.length == 1) {
            //     this.setConfig('tiers_id', all_tiers[0].tiers_id)
            //     const bearer = this.getConfig('token')
            //     this.request.set_headers(bearer, all_tiers[0].tiers_id)
            // }
            this.setConfig('tiers_id', all_tiers[0].tiers_id)
            const bearer = this.getConfig('token')
            this.request.set_headers(bearer, all_tiers[0].tiers_id)

			this.$router.push({
				name: 'Loading',
				query: {
					redirect
				}
			})
        },
        
        /**
         * Récupère la configuration initiale depuis l'endpoint fusionné /user/init
         * et la persiste dans le localStorage via setConfig().
         * Remplace les deux appels séparés persistUserConfig() + pesistUserCaConfig().
         *
         * @returns {Promise<boolean>} true si la configuration a été chargée et stockée,
         *                             false en cas d'erreur ou de réponse vide.
         */
        async persistInitConfig() {
            try {
                const url = Constants.USER_INIT + '?licence_key=' + Constants.USER_LICENCE_KEY
                const res = await this.$request.request_get_api('UserMixin::persistInitConfig', url)
                if (!res || !res.retour) return false

                const r = res.retour

                // --- general config (ex /all_config) ---
                this.setConfig('user_access',   this.$cryptaes.encrypt(r.user_access))
                this.setConfig('acte_groupes',  r.acte_groupes)
                this.setConfig('actes_types',   r.actes_types)
                this.setConfig('horse_race',    r.horse_race)
                this.setConfig('horse_robe',    r.horse_robe)
                this.setConfig('horse_sexe',    r.horse_sexe)
                this.setConfig('table_config',  r.table_config)
                this.setConfig('action_button', r.action_button)
                this.setConfig('action_filter', r.action_filter)
                this.setConfig('lieu_types',    r.lieu_types)
                this.setConfig('debug_level',   r.debug_level)
                this.setConfig('need_reset',    r.need_reset)
                this.setConfig('need_export',   r.need_export)
                this.setConfig('lang',          r.lang || 'fr')
                this.setConfig('translations',  r.translations)
                if (r.pax_countries) this.setConfig('pax_countries', r.pax_countries)
                this.initUserConfig()

                // --- ca config (ex /ca_config) ---
                const ca = r.ca
                this.setConfig('user_rs',                  ca.user_rs)
                this.setConfig('user_firstname',           ca.user_firstname)
                this.setConfig('user_lastname',            ca.user_lastname)
                this.setConfig('user_mail',                ca.user_mail)
                this.setConfig('user_country',             ca.user_country)
                this.setConfig('user_mail_encoded',        ca.user_mail_encoded)
                this.setConfig('default_redirect',         ca.redirect)
                this.setConfig('user_ca_mail',             ca.user_ca_mail)
                this.setConfig('redirect',                 ca.redirect)
                this.setConfig('contract_sire_obligatory', ca.contract_sire_obligatory)
                this.setConfig('configs_horse_sexes',      ca.configs_horse.sexes)
                this.setConfig('configs_horse_races',      ca.configs_horse.races)
                this.setConfig('create_cmep',              ca.create_cmep)
                this.setConfig('authorized_tabs',          this.$cryptaes.encrypt(JSON.stringify(ca.tabs)))
                this.setConfig('ca_config',                JSON.stringify(ca.config))

                EventBus.$emit('UserMixin::initConfigLoaded')
                return true
            } catch (error) {
                console.error('UserMixin::persistInitConfig => An error occured:', error)
                return false
            }
        },

        async pesistUserCaConfig() {
            return this.$request.request_get_api("UserMixin::pesistUserCaConfig", Constants.USER_CA_DETAILS)
                .then(res => {
                    if(!res || !res.retour) return
                    this.setConfig("user_rs", res.retour.user_rs)
                    this.setConfig("user_firstname", res.retour.user_firstname)
                    this.setConfig("user_lastname", res.retour.user_lastname)
                    this.setConfig("user_mail", res.retour.user_mail)
                    this.setConfig("user_country", res.retour.user_country)
                    this.setConfig("user_mail_encoded", res.retour.user_mail_encoded)
                    this.setConfig("default_redirect", res.retour.redirect)
                    this.setConfig("user_ca_mail", res.retour.user_ca_mail)
                    this.setConfig("redirect", res.retour.redirect)
                    this.setConfig("contract_sire_obligatory", res.retour.contract_sire_obligatory)
                    this.setConfig("configs_horse_sexes", res.retour.configs_horse.sexes)
                    this.setConfig("configs_horse_races", res.retour.configs_horse.races)
                    this.setConfig("create_cmep", res.retour.create_cmep)

                    const tabs = JSON.stringify(res.retour.tabs)
                    this.setConfig("authorized_tabs", this.$cryptaes.encrypt(tabs))

                    const config = JSON.stringify(res.retour.config)
                    this.setConfig("ca_config", config)
            })
        },

        async initSession() {
            const licence = this.getConfig('licence_key')
            const licence_name = this.getConfig('licence_name')
            const bearer = this.getConfig('token')
            const tiers_id = this.getConfig('tiers_id')
            
            Constants.USER_LICENCE_KEY = licence
            Constants.USER_NAME = licence_name

            this.request.set_headers(bearer, tiers_id)
            this.setUserLoggedIn()
            // Synchronise le store avec le localStorage avant setLanguage
            // pour éviter un POST /config/lang inutile à chaque rechargement
            const lang = this.getConfig('lang', 'fr')
            this.userLang = lang
            this.setLanguage(lang)
        },

        async setLanguage(lang) {
            const oldLang = this.userLang
            loadLocale(lang)

            Vue.i18n.set(lang)
            this.userLang = lang

            // Le localstorage est toujours nécessaire, au démarrage du logiciel, la bdd n'est pas encore setup
            this.setConfig('lang', lang)

            if (oldLang != lang) {              
                await this.$request.request_post_api(
                    "UserMixin::setLanguage",
                    Constants.USER_SET_LANG,
                    { lang },
                    false
                )
            }

            const bearer = this.getConfig('token')
            const tiers_id = this.getConfig('tiers_id')
            this.$request.set_headers(bearer, tiers_id)
        },

        checkUserValid() {
            return ConfigMixin.methods.getConfig('valid_mail') || false
        },
        getUserMail() {
            return ConfigMixin.methods.getConfig('user_mail') || null
        },
        getUserMailEncoded() {
            return ConfigMixin.methods.getConfig('user_mail_encoded') || null
        },
        getUserCAMail() {
            return ConfigMixin.methods.getConfig('user_ca_mail') || null
        },
        defaultCaRedirect() {
            return ConfigMixin.methods.getConfig('default_redirect') || 'HomeMenu'
        },

        checkTiersSelected: function() {
            return ConfigMixin.methods.getConfig('tiers_id')
        },
        getConfigHorseSexes() {
            const config = ConfigMixin.methods.getConfig('configs_horse_sexes')
            if(config) {
                return config.split(',')
            }
            return []
        },
        getConfigHorseRaces() {
            const config = ConfigMixin.methods.getConfig('configs_horse_races')
            if(config) {
                return config.split(',')
            }
            return []
        },

        async submitAutoLog(email, token) {
            if(this.checkLocal()) {
                await this.delogUser(false, false)
            }

            return this.$request.request_post_api("UserMixin::submitAutoLog", Constants.USER_AUTOLOGIN, {
                email: email,
                signature: token
            }, false, { sync:false })
            .then(response => {
                if(response.code_retour === 0) {
                    const data = response.retour
                    this.persistUserSession(data.token, data.licence_key, data.licence_username, data.user_id, data.valid_user, data.valid_mail, data.lang)
                    this.persistUserLicence(data)
                    this.need_valid_mail = data.valid_mail
                }
            })
        },
        async getRedirectUrl(lang = null) {
            let url = Constants.USER_REDIRECT_URL
            if(lang) {
                url += '?lang=' + lang
            }
            return this.$request.request_get_api("UserMixin::getRedirectUrl", url)
        },

        delogUser: async function(keep_config=false, redirect=true) {
            await this.$request.request_get_api("UserMixin::delogUser", Constants.USER_LOGOUT)
                .then(async res => {
                    this.deleteLocalData(redirect)
                })
                .catch(e => {
                    this.deleteLocalData(redirect)
                })
        },

        deleteLocalData(redirect) {
            this.rmConfig()
            this.rmConfigCache()
            this.request.reset_header()

            this.$router.user_logged = false

            // On ne redirige que si le delog ne vient pas du switch licence
            if(this.$route.name != "Home" && redirect) {
                this.$router.push("/")
            }
        },

        sendAutolog: async function(mail, lang) {
            const url = Constants.USER_SEND_AUTOLOG
            return await this.$request.request_post_api("UserMixin::sendAutolog", url, {mail, lang}, false)
        },

        updatePassword(password) {
            const url = Constants.PASSWORD_URL
            const params = {
                password
            }

            return this.$request.request_post_api("UserMixin::updatePassword", url, params, false)
            .catch(this.$request.parseError)
        },

        resetPasswordWithToken(email, token, password) {
            const url = Constants.UPDATE_PWD_URL
            const params = {
                email,
                token,
                password
            }

            return this.$request.request_post_api("UserMixin::resetPasswordWithToken", url, params, false)
            .catch(this.$request.parseError)
        },

        async getTiersByUser() {
            const url = Constants.TIERS_BY_USER
            const result = await this.$request.request_get_api("UserMixin::getTiersByUser", url)
            .catch(error => {
                console.log("UserMixin::getTiersByUsers => ERROR", error)
                return null
            })
            if(result.code_retour == 0) return result.retour
            return
        }
    }
})
